export { Card } from "./card";
export type { CardProps } from "./card";